/* eslint-disable quote-props */
const alert = {
  'alert.401': 'Not authorized',
  'alert.404': 'Not found',
  'alert.500': 'Internal server error',
  'alert.dataFailedToRetrieve': 'Data failed to retrieve',
  'alert.refreshPage': 'odśwież stronę',
}

const channelsFloorspaceModal = {
  'channelsFloorspaceModal.company': 'Company',
  'channelsFloorspaceModal.floorSpacePerStoreCurrent': 'Avg. shop floorspace',
  'channelsFloorspaceModal.revenuePerM2Current': 'Revenue/m²',
  'channelsFloorspaceModal.storesCurrent': 'Stores quantity',
  'channelsFloorspaceModal.surface': 'Surface',
}

const channelsTabs = {
  'channelsTabs.channels': 'Channels',
  'channelsTabs.countries': 'Countries',
  'channelsTabs.owners': 'Owners',
  'channelsTabs.saleTypes': 'Sale types',
}

const clubCardModal = {
  'clubCardModal.application': 'Application',
  'clubCardModal.company': 'Company',
  'clubCardModal.newClubCards': 'New club cards',
  'clubCardModal.no': 'No',
  'clubCardModal.revenueClubCCC': 'Revenue Club CCC',
  'clubCardModal.shareClubCard': 'Share club cards',
}

const config = {
  language: 'en',
}

const countries = {
  'countries.apparel': 'Apparel',
  'countries.austria': 'Austria',
  'countries.bulgaria': 'Bulgaria',
  'countries.croatia': 'Croatia',
  'countries.czechrepublic': 'Czech Republic',
  'countries.deezee': 'Deezee',
  'countries.EOB2': 'EOB2',
  'countries.eobuwie': 'eobuwie.pl',
  'countries.estonia': 'Estonia',
  'countries.germany': 'Germany',
  'countries.ginorossi': 'Gino-Rossi',
  'countries.halfprice': 'Halfprice',
  'countries.hungary': 'Hungary',
  'countries.latvia': 'Latvia',
  'countries.lithuania': 'Lithuania',
  'countries.modivo': 'Modivo',
  'countries.moldova': 'Moldova',
  'countries.none': '-',
  'countries.outlet': 'CCC Outlet',
  'countries.poland': 'Poland',
  'countries.romania': 'romania',
  'countries.russia': 'Russia',
  'countries.serbia': 'Serbia',
  'countries.slovakia': 'Slovakia',
  'countries.slovenia': 'Slovenia',
  'countries.switzerland': 'Switzerland',
  'countries.turkey': 'Turkey',
  'countries.ukraine': 'Ukraine',
  'countries.vogele': 'Vogele',
}

const menu = {
  'menu.behalfOfUserName': 'On behalf of {{user}}',
  'menu.date.chooseDate': 'Choose Date',
  'menu.date.dayBeforeYesterday': 'Day before yesterday',
  'menu.date.today': 'Today',
  'menu.date.todayWarning': 'no data',
  'menu.date.yesterday': 'Yesterday',
  'menu.date': '(sales date: {{date}})',
  'menu.help': 'Help',
  'menu.info': 'About',
  'menu.language.english': 'English',
  'menu.language.polish': 'Polish',
  'menu.language.title': 'Language',
  'menu.localCurrency.no': 'Group currency (PLN)',
  'menu.localCurrency.title': 'Select currency',
  'menu.localCurrency.yes': 'Local currency',
  'menu.logout': 'Log out',
  'menu.myProfile': 'My Profile',
  'menu.reportBug': 'Make suggestion',
  'menu.revenue': 'REVENUE',
  'menu.title': 'CCC Group',
  'menu.traffic': 'TRAFFIC',
}

const myResults = {
  'myResults.avgCart': 'Avg. basket',
  'myResults.avgCartCCC': 'Avg. basket CCC',
  'myResults.avgConversion': 'Avg. conversion',
  'myResults.avgPerStore': 'Avg. / store',
  'myResults.avgRevenuePerStore': 'Avg. revenue per store:',
  'myResults.ranking': 'Ranking',
  'myResults.revenue': 'Revenue',
  'myResults.revenueM2': 'Sales / m²',
  'myResults.sales': 'sales',
  'myResults.title': 'MY RESULTS vs MEDIUM REGION',
}

const date = {
  'date.apply': 'Apply',
  'date.cancel': 'Cancel',
  'date.closedPeriod.halfyear': 'halfyear',
  'date.closedPeriod.month': 'month',
  'date.closedPeriod.quarter': 'quarter',
  'date.closedPeriod.week': 'week',
  'date.closedPeriod.week2': '2 weeks',
  'date.closedPeriods.range.halfyear': 'halfyear',
  'date.closedPeriods.range.month': 'months',
  'date.closedPeriods.range.quarter': 'quarters',
  'date.closedPeriods.range.week': 'weeks',
  'date.closedPeriods.range.week2': '2 weeks',
  'date.comparisonDate': 'Comparison date',
  'date.dataRange': 'The scope of data',
  'date.datePicker': 'Date selection',
  'date.dayMonthFormat': 'ddd MM/DD',
  'date.from': 'From',
  'date.from.day': 'Day to compare',
  'date.from.month': 'From the beginning of month',
  'date.from.month2': 'From the beginning of month vs L2Y',
  'date.from.month2e1': 'From the beginning of month vs LY for ecom and L2Y for B&M',
  'date.from.quarter': 'From the beginning of quarter',
  'date.from.quarter2': 'From the beginning of quarter vs L2Y',
  'date.from.quarter2e1': 'From the beginning of quarter vs LY for ecom and L2Y for B&M',
  'date.from.year': 'From the beginning of year',
  'date.from.year2': 'From the beginning of year vs L2Y',
  'date.from.year2e1': 'From the beginning of year vs LY for ecom and L2Y for B&M',
  'date.fromDate.halfyear': 'from beginning of halfyear (HTD)',
  'date.fromDate.month': 'from beginning of month (MTD)',
  'date.fromDate.quarter': 'from beginning of quarter (QTD)',
  'date.fromDate.week': 'from beginning of week (WTD)',
  'date.fromDate.year': 'from beginning of year (YTD)',
  'date.perClosedPeriods': 'for closed periods',
  'date.perDay': 'for day',
  'date.perEndDate': 'till date',
  'date.perEndDateDescription': 'The application will show the cumulative results from the beginning of the selected period, i.e. ',
  'date.pickedDate': 'Pick day (TD)',
  'date.salesDate': 'Sales date',
  'date.selectComparisonDate': 'Pick comparison date',
  'date.selectedEndDate': 'Selected end date',
  'date.selectSalesDate': 'Pick sales date',
  'date.showResultPer': 'Application will show cumulative results for {{period}} period',
  'date.to': 'to',
  'date.typeAnalysis': 'Analysis type:',
  'date.year': 'Year',
}

const common = {
  'common.date': 'Date',
  'common.noInternetConnection': 'No Internet connection',
}

const rankings = {
  'rankings.best20Shops': 'Best 20 shops',
  'rankings.clubCardsCurrent': 'New cards',
  'rankings.clubShareCurrent': 'Share sales',
  'rankings.companies': 'Companies',
  'rankings.companiesByChannels': 'Companies according to channels',
  'rankings.companiesClubCard': 'Companies with club members',
  'rankings.companiesEcommerce': 'Companies e-commerce',
  'rankings.companiesEcommerceOrders': 'Companies e-commerce - orders',
  'rankings.companiesStationary': 'Companies stationary',
  'rankings.company': 'Company',
  'rankings.companyMulti': 'companies',
  'rankings.companyMulti2': 'companies',
  'rankings.companySingle': 'company',
  'rankings.comparison': 'Porównanie',
  'rankings.confirm': 'CONFIRM',
  'rankings.conversionCurrent': 'Average conversion',
  'rankings.dailyRange': 'Daily range',
  'rankings.district': 'District',
  'rankings.emptyDistrictManager': '(empty)',
  'rankings.fetchError': 'We can not download data, check your internet connection and try to refresh the page',
  'rankings.found': 'Selected {{count}} {{stores}}',
  'rankings.hoursRevenue': 'Hours revenue',
  'rankings.indicator': 'Indicator:',
  'rankings.modalFilterCountryTitle': 'Filter ranking',
  'rankings.ordersPerDay': 'Orders per day',
  'rankings.pos': 'Pos',
  'rankings.revenueChange': 'Increase vs LY %',
  'rankings.revenueClubCurrent': 'Club revenue [zł]',
  'rankings.revenueClubCurrentLabel': 'Club revenue',
  'rankings.revenueCurrent': 'Revenue',
  'rankings.revenuePerDay': 'Revenue per day',
  'rankings.revenuePerM2Current': 'Revenue/m² [zł]',
  'rankings.revenuePerM2CurrentLabel': 'Revenue/m²',
  'rankings.revenuePerStoreCurrent': 'Avg. revenue',
  'rankings.revenuePerStoreCurrentLabel': 'Average on the number of stores',
  'rankings.rks': 'RKS',
  'rankings.search': 'Search...',
  'rankings.shareCurrent': 'Share in sales %',
  'rankings.shop': 'Shop',
  'rankings.storesEcommerceOrders': 'Stores e-commerce - orders',
  'rankings.storesOpenWithin12Months': 'Stores open within 12 months',
  'rankings.storesOpenWithin30Days': 'Stores open within 30 days',
  'rankings.storesStationary': 'Stationary stores',
  'rankings.title': 'Rankings',
  'rankings.trafficCurrent': 'Traffic',
  'rankings.trafficPerStoreCurrent': 'Average store movement',
  'rankings.transactionValueClubCurrent': 'Avg. value of club basket',
  'rankings.transactionValueCurrent': 'Avg basket value [zł]',
  'rankings.transactionValueCurrentLabel': 'Average basket value',
  'rankings.websiteEcommerce': 'Websites e-commerce',
  'rankings.websites': 'Websites',
  'rankings.weeklyRange': 'Weekly range',
  'rankings.worst20Shops': 'Worst 20 shops',
}

const ReportBugDialog = {
  'ReportBugDialog.description': 'Description',
  'ReportBugDialog.report': 'Report',
  'ReportBugDialog.title': 'Title',
}

const returnsValueDetails = {
  'returnsValueDetails.returns': 'Returns',
  'returnsValueDetails.returnsValueShareCurrent': 'Share',
  'returnsValueDetails.sum': 'Sum',
}

const revenue = {
  'revenue.budget': 'Budget',
  'revenue.changedCompared': 'change reported',
  'revenue.cluster': 'Cluster',
  'revenue.contribution': 'Contribution',
  'revenue.dataDownloadingIsInProgress': 'Data downloading is in progress',
  'revenue.dataSource': 'Data source',
  'revenue.details.clubCard': 'CCC Club',
  'revenue.details.clubCard.averageTransactionValue': 'Average transaction value',
  'revenue.details.clubCard.clubCardTransactions': 'Club card transactions',
  'revenue.details.clubCard.newCardsOnGivenDay': 'New cards on a given day',
  'revenue.details.clubCard.shareStoreSale': 'Share in the store sale',
  'revenue.details.esizemeProfileUsage': 'profile usage',
  'revenue.details.esizemeScans': 'scans',
  'revenue.details.general': 'General',
  'revenue.details.lastData': 'Last data',
  'revenue.details.ordersByOriginAndSource': 'Orders by origin and place of fulfillment',
  'revenue.details.origin': 'Origin',
  'revenue.details.replenishment': 'Replenishment',
  'revenue.details.replenishment.other': 'other',
  'revenue.details.replenishment.replenishmentLever7Days': 'Provision level 7 days',
  'revenue.details.replenishment.shoes': 'shoes',
  'revenue.details.result': 'Result',
  'revenue.details.result.conversion': 'Conversion',
  'revenue.details.result.date': 'Day',
  'revenue.details.result.dayToDay': 'Day to day',
  'revenue.details.result.number': 'Number',
  'revenue.details.result.qtd': 'QTD',
  'revenue.details.result.sale': 'Sale',
  'revenue.details.result.saleWithoutReturns': 'Sale w/o returns',
  'revenue.details.result.sharePerStore': 'Share / Store',
  'revenue.details.result.traffic': 'Traffic',
  'revenue.details.result.weather': 'Weather',
  'revenue.details.result.ytd': 'YTD',
  'revenue.details.revenueByOriginAndSource': 'Revenue by origin and place of fulfillment',
  'revenue.details.sale': 'Revenue',
  'revenue.details.stores': 'Stores',
  'revenue.details.summary': 'Summary',
  'revenue.details.total': 'Total',
  'revenue.details.traffic': 'Traffic',
  'revenue.details.traffic.average': '7 days average',
  'revenue.details.traffic.day': 'Day',
  'revenue.details.traffic.LY': 'LY',
  'revenue.details.traffic.today': 'Traffic today',
  'revenue.details.traffic.vsLY': 'Traffic vs LY',
  'revenue.details.traffic.week': 'Traffic 7 days',
  'revenue.details.warehouse': 'Warehouse',
  'revenue.ecom.legend': 'Average value',
  'revenue.express': 'Express',
  'revenue.fair': 'Fair',
  'revenue.floorSpaceDecreased': 'floor space decreased',
  'revenue.floorSpaceIncreased': 'floor space increased',
  'revenue.lifting': 'Lifting',
  'revenue.ly': 'LY',
  'revenue.necom.legend': 'Average/store',
  'revenue.new': 'New',
  'revenue.noComparableStoresOpen': 'No {{type}} stores open',
  'revenue.noData': 'no data',
  'revenue.noOnlineReportingStores': 'No {{type}} online stores',
  'revenue.noOpenStationaryStores': 'No {{type}} stationary stores',
  'revenue.noOpenStoresWithAChangeOfArea': 'No {{type}} stores with area change',
  'revenue.noOpenStoresWithFloorDecrease': 'No {{type}} stores with decrease area',
  'revenue.noOpenStoresWithFloorIncrease': 'No {{type}} stores with increase area',
  'revenue.noOrdersToEcom': 'No orders for online stores',
  'revenue.noStores': 'There was no shop on that day and none of them changed their surface during the last 30 days',
  'revenue.plan': 'vs plan',
  'revenue.pp': 'p.p.',
  'revenue.promotion': 'promotion',
  'revenue.revenue': 'Revenue',
  'revenue.salesWithoutReturns': 'Sprzedaż bez zwrotów:',
  'revenue.sisterStores': 'Sister stores',
  'revenue.stats.average': 'Average',
  'revenue.stats.averageShort': 'Avg:',
  'revenue.stats.avgL4L': 'Avg. L4L',
  'revenue.stats.avgNew': 'Avg. new',
  'revenue.stats.avgSurfaceShort': 'Avg sur.',
  'revenue.stats.avgSurfaceShortCCC': 'Avg sur. CCC',
  'revenue.stats.comparableDay': 'Comparable day',
  'revenue.stats.compare': 'Compare',
  'revenue.stats.completeness': 'Data completeness',
  'revenue.stats.completeness.activeClosed': 'Closed according to schedule',
  'revenue.stats.completeness.back': 'Back',
  'revenue.stats.completeness.closedReporting': 'Closed reporting',
  'revenue.stats.completeness.company': 'Company',
  'revenue.stats.completeness.delayedRtlog': 'No reports in rtlog',
  'revenue.stats.completeness.delayedStores': 'Stores without update',
  'revenue.stats.completeness.header': 'DATA UPDATE',
  'revenue.stats.completeness.hour': 'Hour',
  'revenue.stats.completeness.latestReports': 'Latest reports',
  'revenue.stats.completeness.noActiveClosed': 'All stores have been open according to the calendar in the last two hours.',
  'revenue.stats.completeness.noActiveClosedAfter16': 'All stores were open according to the calendar after 4 p.m..',
  'revenue.stats.completeness.noDelayedStores': 'All stores have reported data in last 2 hours.',
  'revenue.stats.completeness.noDelayedStoresAfter16': 'All stores have reported data after 16.',
  'revenue.stats.completeness.noReports': 'Companies not reporting data to Utargi',
  'revenue.stats.completeness.noZeroReporting': 'All stores reported non-zero sales after 4 p.m..',
  'revenue.stats.completeness.noZeroReportingAfter16': 'All stores reported non-zero sales in the last two hours.',
  'revenue.stats.completeness.reason': 'Reason',
  'revenue.stats.completeness.store': 'Store',
  'revenue.stats.completeness.storesECom': 'websites',
  'revenue.stats.completeness.storesNECom': 'stacionary stores',
  'revenue.stats.completeness.storesReportingZero': 'Reported zero revenue in the last hour.',
  'revenue.stats.completeness.storesReportingZeroAfter16': 'Reported zero sales after 4PM.',
  'revenue.stats.completeness.storesReportingZeroPerDay': 'Reported zero revenue on the selected date.',
  'revenue.stats.completeness.storesWithoutReports': "Haven't reported data in last hour.",
  'revenue.stats.completeness.storesWithoutReportsAfter16': "Haven't reported data after 16.",
  'revenue.stats.completeness.storesWithoutReportsPerDay': "Haven't reported data in selected date.",
  'revenue.stats.completeness.zeroReporting': 'Reporting no sales',
  'revenue.stats.generalSurface': 'General surface',
  'revenue.stats.l4l': 'L4L',
  'revenue.stats.new': 'Nowe',
  'revenue.stats.quantityL4L': 'Qu. L4L',
  'revenue.stats.quantityNew': 'Qu. new',
  'revenue.stats.sale': 'sale',
  'revenue.stats.store': 'Store',
  'revenue.stats.stores': 'Stores',
  'revenue.stats.storesActive': 'Stores active',
  'revenue.stats.storesAlt': 'Stores',
  'revenue.stats.storesOpen': 'Stores open',
  'revenue.stats.surface': 'Retail space',
  'revenue.stats.together': 'Together',
  'revenue.stats.traffic': 'Traffic',
  'revenue.stats.websitesActive': 'Websites active',
  'revenue.stats.websitesOpen': 'Websites open',
  'revenue.store': 'store',
  'revenue.stores': 'stores',
  'revenue.storesAlt': 'stores',
  'revenue.summary': 'Summary',
  'revenue.table.category': 'Category',
  'revenue.table.closeDate': 'Close date',
  'revenue.table.concept': 'Concept',
  'revenue.table.from': 'from',
  'revenue.table.openDate': 'Open date',
  'revenue.table.openingHours': 'Opening hours',
  'revenue.table.regionManagerPhone': 'Phone number RKS',
  'revenue.table.renovations': 'Renovations',
  'revenue.table.rks': 'RKS',
  'revenue.table.trim': 'Trim',
  'revenue.type.active': 'active',
  'revenue.type.open': 'open',
  'revenue.type.reporting': 'reporting',
  'revenue.type.selling': 'selling',
  'revenue.website': 'Website',
  'revenue.websites': 'Websites',
  'revenue.websitesAlt': 'Websites',
}

const tableClubCard = {
  'tableClubCard.avgValue': 'Avg. value',
  'tableClubCard.clubRevenue': 'Club revenue',
  'tableClubCard.newCards': 'New cards',
  'tableClubCard.percentRevenue': '% revenue',
}

const tableEsize = {
  'tableEsize.esize': 'esize.me',
  'tableEsize.esizemeShareCurrent': '% from profile',
}

const tableMargin = {
  'tableMargin.margin': 'Margin',
  'tableMargin.grossProfit': 'Gross profit',
}

const tableOrders = {
  'tableOrders.ordersShare': 'Share number',
  'tableOrders.orders': 'Orders',
  'tableOrders.ordersValueShare': 'Share value',
  'tableOrders.ordersValue': 'Orders value',
  'tableOrders.orderValue': 'Avg. order',
}

const tableReplenishment = {
  'tableReplenishment.replenishmentShoes': 'Replenishment shoes',
  'tableReplenishment.replenishmentOther': 'Replenishment other',
}

const tableSourceData = {
  'tableSourceData.resa': 'Resa',
  'tableSourceData.traffic': 'Traffic',
  'tableSourceData.expos': 'Expos',
}

const tableTraffic = {
  'tableTraffic.traffic': 'Traffic',
}

const tableWeather = {
  'tableWeather.weather': 'Weather',
}

const box = {
  'box.allStores': 'All stores',
  'box.allWebsites': 'All websites',
  'box.browse': 'Browse:',
  'box.changed1yStores': 'Surface changed last year',
  'box.changed30dStores': 'Surface changed in last 30 days',
  'box.floorSpaceDecreased1yOnly': 'Surface decreased last year',
  'box.floorSpaceDecreased30dOnly': 'Surface decreased in last 30 days',
  'box.floorSpaceIncreased1yOnly': 'Surface increased last year',
  'box.floorSpaceIncreased30dOnly': 'Surface increased in last 30 days',
  'box.new': 'New',
  'box.newStores': 'Stores open for up to six months',
  'box.newWebsites': 'Websites open for up to six months',
  'box.opened1yStores': 'Opened last year',
  'box.stationary': 'Stationary',
  'box.website': 'Website',
}

const currency = {
  numberLocale: 'en-US',
  thousands: 'K {{currency}}',
  millions: 'M {{currency}}',
}

const errorPages = {
  'error.auth': 'Wrong email or password',
  'error.hint': 'Try reload the application',
  'error.maintenance': 'Maintenance in progress',
  'error.message': 'Something went wrong',
  'error.ok': 'OK',
  'error.reload': 'Reload',
  'error.till': 'till',
  'noAccess.help': 'Help',
  'noAccess.hint': 'If you have active account and cannot login, contact with Help Desc',
  'noAccess.message': "We couldn't detect your right for app usage",
}

const auth = {
  'auth.login': 'Login',
  'auth.password': 'Password',
  'auth.submit': 'Sign in',
  'auth.email': 'Email',
}

const search = {
  'search.title': 'Search for a store',
  'search.results': 'Search results',
  'search.back': 'Back to search',
  'search.backToResults': 'Back to results',
  'search.found': 'Selected {{count}} {{stores}}',
  'search.shopSingle': 'store',
  'search.shopMulti': 'stores',
  'search.shopMulti2': 'stores',
  'search.clear': 'Clear',
  'search.view': 'Details',
  'search.empty': 'No stores to show',
  'search.emptySearchField': 'Type at least 3 letters to see search results',
  'search.table.shop': 'Store',
  'search.table.revenue': 'Revenue',
  'search.table.concept': 'Conc.',
  'search.table.percent': '%',
  'search.selectedItems': 'Other stores',
}

export default {
  ...alert,
  ...auth,
  ...box,
  ...channelsFloorspaceModal,
  ...channelsTabs,
  ...clubCardModal,
  ...common,
  ...config,
  ...countries,
  ...currency,
  ...date,
  ...errorPages,
  ...menu,
  ...myResults,
  ...rankings,
  ...ReportBugDialog,
  ...returnsValueDetails,
  ...revenue,
  ...search,
  ...tableClubCard,
  ...tableEsize,
  ...tableMargin,
  ...tableOrders,
  ...tableReplenishment,
  ...tableSourceData,
  ...tableTraffic,
  ...tableWeather,
}
